import React from "react";
import BlogSidebar from "../components/blog/sidebar";
import Seo from "../components/common/seo";
import { toPlainText } from "@portabletext/react";
import { Link } from "gatsby";

const DigitalIssue = ({ pageContext }) => {
  const { digitalIssue } = pageContext;
  return (
    <div className="videopage container">
      <div className="left">
        <h1>{digitalIssue.title}</h1>
        <div className="max-w-sm">
          {digitalIssue.image && (
            <img
              src={digitalIssue.image}
              alt={digitalIssue.title}
              className="w-full h-full object-contain"
            />
          )}
        </div>
        {typeof digitalIssue.body === "string" && (
          <div
            className="mt-[40px]"
            dangerouslySetInnerHTML={{ __html: digitalIssue.body }}
          />
        )}

        <div className="mt-[40px]">
          <a
            target="_blank"
            href={digitalIssue.digital_issue_url}
            className="button text-[#fff] border border-solid border-white rounded-full px-4 py-3 no-underline hover:bg-white
            hover:text-black active:text-[#fff] visited:text-[#fff]"
          >
            Read Publication
          </a>
        </div>
      </div>
      <div className="right">
        <BlogSidebar
          iframes={[
            "99ab7fbf-afbd-4461-b35f-ebba9abf2373",
            "99ab7ff3-9c95-4ec4-a7f6-6138d103366c",
          ]}
        />
      </div>
    </div>
  );
};

export function Head({ location, pageContext }) {
  const { digitalIssue } = pageContext;
  const seoData = {
    title: digitalIssue?.title,
    description:
      typeof digitalIssue.body === "string" && toPlainText(digitalIssue.body),
    image: digitalIssue?.image,
  };

  return <Seo location={location} data={seoData} />;
}

export default DigitalIssue;
